<template>
  <v-dialog
    v-model="dialog"
    max-width="500"
  >
    <v-card>
      <v-card-title class="headline">Test call center</v-card-title>

      <v-card-text class="pt-0">
        <v-text-field
        ref="extension"
          label="Extension"
          v-model="extension"
              :rules="[validate.required]"
        ></v-text-field>
        <v-text-field
        ref="phone"
          label="Phone"
          v-model="phone"
              :rules="[validate.required]"
        ></v-text-field>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          flat="flat"
          @click="confirm"
        >
          Test
        </v-btn>

        <v-btn
          color="grey darken-1"
          flat="flat"
          @click="dialog = false"
        >
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from '@/utils/validate';

export default {
  props: {
    description: {
      type: String,
      default: 'Bạn có muốn xóa?'
    }
  },

  data: () => ({
    validate: validate,
    dialog: false,
    extension: null,
    phone: null
  }),

  methods: {
    open () {
      this.dialog = true;
    },

    close () {
      this.dialog = false;
      this.$refs.extension.reset();
      this.$refs.phone.reset();
    },

    confirm () {
      if (!this.$refs.extension.validate(true) || !this.$refs.phone.validate(true)) return;

      let data = {
        number: this.phone,
        extension: this.extension,
        action: 'Connected'
      };
      window.getApp.$refs.dialogCallCenter.open(data);
      this.close();
      // this.$emit('confirm');
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/DialogTestCallCenter.vue